/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { invoiceSettingsShow } from '../../axios/invoiceSettingsShow'
import type {
	InvoiceSettingsShowError,
	InvoiceSettingsShowPathParams,
	InvoiceSettingsShowResponse,
} from '../../types/InvoiceSettingsShow'

export const invoiceSettingsShowQueryKey = (organisation: InvoiceSettingsShowPathParams['organisation']) =>
	[{ url: '/:organisation/invoice-settings', params: { organisation } }] as const

export type InvoiceSettingsShowQueryKey = ReturnType<typeof invoiceSettingsShowQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceSettingsController.php InvoiceSettingsController::show */
export function invoiceSettingsShowQueryOptions(
	organisation: InvoiceSettingsShowPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		InvoiceSettingsShowResponse,
		AxiosError<InvoiceSettingsShowError>,
		InvoiceSettingsShowResponse,
		InvoiceSettingsShowQueryKey
	>({
		queryKey: invoiceSettingsShowQueryKey(organisation),
		queryFn: ({ signal }) => invoiceSettingsShow(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceSettingsController.php InvoiceSettingsController::show */
export function useInvoiceSettingsShow<TSelectData = InvoiceSettingsShowResponse>(
	organisation: InvoiceSettingsShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					InvoiceSettingsShowResponse,
					AxiosError<InvoiceSettingsShowError>,
					TSelectData,
					InvoiceSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<InvoiceSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...invoiceSettingsShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceSettingsController.php InvoiceSettingsController::show */
export function useInvoiceSettingsShowSuspense<TSelectData = InvoiceSettingsShowResponse>(
	organisation: InvoiceSettingsShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					InvoiceSettingsShowResponse,
					AxiosError<InvoiceSettingsShowError>,
					TSelectData,
					InvoiceSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<InvoiceSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...invoiceSettingsShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
